import React, { useState, useEffect} from 'react';
import { Container, Card, Button, Col, Row, Image } from 'react-bootstrap';
import SigninLink from '../components/SigninLink';
import signInImage from '../assets/signin-pg-img.svg';
import SupportModal from '../components/SupportModal';
import { Link } from 'react-router-dom';
import { useConfigItem } from '../serverConfigContext/useServerConfig';

import '../styles/main.scss';

function SignedOutPage({ workspaceHint=null, special=null, userOnboard=null, userStatus=null, passedSignUp }) {
    //userStatus is used to determine if the user is onboarded/approved or not, if they are not, then we show pending approval message

    const heroContent = useConfigItem('workspaceHeroContent')[0] ?? null;

    let [ supportModalShown, setSupportModalShown ] = useState(false);
    let [ supportContext ] = useState();
    // let [ signUpError, setSignupError ] = useState(null);
    const [windowWidth, setWindowWidth] = useState();

    const setSupportModalIsShown = (newVal) => {
        setSupportModalShown(!!newVal);
    }

    const updateDimensions = () => {
        setWindowWidth(window.innerWidth)
    }

    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    // eslint-disable-next-line    
    }, []);

    return (
        <Row>
            <Container className='signin-landing-page'>
                <Col className='signin-col' sm={12} md={12} lg={12} xl={6}>
                    <Row>
                        <h1 className='h1'>{heroContent?.fields?.titleText ?? 'Linksbridge Workspace'}</h1>
                        <h3 className='h3'>{heroContent?.fields?.subTitleText ?? 'Customized platform solutions for global health data and market intelligence'}</h3>
                        <p className='p1'>{heroContent?.fields?.description ?? 'Linksbridge Workspace provides end-to-end data management and hosting services to help global health counterparts transform market data into strategic assets.'}</p>
                        {/* <p className='p2'>We apply our established data infrastructure and management systems to platforms customized for your priorities.</p> */}
                    </Row>
                    <Row className='welcome-back justify-center'>
                        <Card className='surface-primary-background max-width-500-px'>
                            <div className='signin-btn'>
                            {
                            (userOnboard && userOnboard.userInfo && (userOnboard.userInfo.state === 'PENDING_APPROVAL' || userOnboard.userInfo.state === 'JUST_SIGNED_UP' || userOnboard.userInfo.status === 'unauthenticated')) ?
                                <>
                                    <h2 className="h2 m-b-end-06">Your request has been submitted</h2>
                                    <p className='label-large'>Your account will be reviewed and our team will get back to you within 3 business days with a confirmation email.</p>
                                    <p className='label-large'>Need additional help? Contact <a className='underline-none' href='mailto:contact@linksbridge.com'>contact@linksbridge.com</a></p>
                                                    
                                </>
                                :
                                <>
                                    <h3 className='body-med'>Log in or Request Access</h3>
                                    <p>Log in with your Microsoft, Google, or organizational email account. <i>First time? We’ll prompt you to request access.</i></p>
                                    <Row className='flex-row' style={{flexWrap: 'nowrap', justifyContent: 'center'}}>
                                        <SigninLink>
                                            <Button style={{ margin: 'auto', cursor: 'pointer'}} className="w-100 m-b-end-06 orange-500 text-primary-dark">
                                                <strong>Log In</strong>
                                            </Button>
                                        </SigninLink>
                                    </Row>
                                    
                                </>
                                    
                            }
                                <p className='body-med policies-p align-center'>

                                    <Link className='terms-of-use' to={{ pathname: "https://www.iubenda.com/terms-and-conditions/62216506" }} target="_blank">
                                        Terms of Use
                                    </Link>
                                    {'•'}
                                    <Link className='privacy-policy' to={{ pathname: "https://linksbridge.com/privacy-policy" }} target="_blank">
                                        Privacy Policy
                                    </Link>
                                     {'•'}
                                    <Link className='contact-us' to={{ pathname: "mailto:support@linksbridge.com?subject=Workspace%20Support%20Request" }} target="_blank">
                                        Contact Us
                                    </Link>
                                </p>

                            </div>
                        </Card>
                    </Row>
                </Col>
                {
                    !windowWidth || windowWidth > 1200 ?
                        <Col className='img-col' sm={12} md={12} lg={12} xl={6} >
                            <Image
                                src={signInImage}
                                alt='SignIn-Workspace-img'
                                style={{
                                    width: "100%",
                                
                                }} />
                        </Col>
                    : ''
                }
                <SupportModal
                    userEmail={''}
                    show={supportModalShown}
                    onSubmitted={setSupportModalIsShown}
                    contextInfo={supportContext}
                />
            </Container>
        </Row>
    )
}

export default SignedOutPage